import pricingCustom from '@assets/images/pricingCustom.png';
import { CTAButton } from '@components';
import Plans, { planDuration } from '@containers/Pricing/constants/Plans';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { useState } from 'react';
import PlanCard from './components/PlanCard';
import PlanSwitcher from './components/PlanSwitcher';
import styles from './styles.module.scss';

const PricePlan = () => {
  const router = useRouter();
  const [selectedPlan, setSelectedPlan] = useState<planDuration>('monthly');

  return (
    <div className={styles.pricePlanContainer} id="price-plan">
      <h1 className={styles.title}>Find the Right Plan for Your Team&rsquo;s Engagement Goals</h1>

      <div className={styles.planSwitcherContainer}>
        <PlanSwitcher selectedPlan={selectedPlan} setSelectedPlan={setSelectedPlan} />
      </div>

      <div className={styles.planCardContainer}>
        {Plans.map((plan) => (
          <div key={plan.id} className={styles.planCardItemContainer}>
            <PlanCard
              {...plan}
              price={plan.price[selectedPlan]}
              unit={plan.unit[selectedPlan]}
              onCtaClick={() => router.push('/get-started/register')}
            />
          </div>
        ))}
      </div>

      {/* custom part */}
      <div className={styles.customContainer}>
        <Image src={pricingCustom} alt="Pricing Custom Icon" className={styles.image} />
        <div>
          <div className={styles.title}>Custom</div>
          <div className={styles.desc}>
            Tailored for enterprises — our team will work with you to build a solution that fits
            your unique goals and culture.
          </div>
        </div>
        <CTAButton
          variant="outlined"
          className={styles.button}
          onClick={() => router.push('/schedule-a-demo')}
        >
          <span>Contact Sales</span>
        </CTAButton>
      </div>
    </div>
  );
};

export default PricePlan;
